import React from 'react';
import Records from './records';

const RechargeRecords = () => {
  return <Records type="recharge" />;
};

export default RechargeRecords;
